module.exports = {"ru":{"modules":{"panelmenu":{"tabbarTitle":"Меню","misc":{"gmb":{"title":"создано с помощью"}}}}}}